import { useState } from 'react';
import { ADMIN_EXECUTIVE_ID, ADMIN_MANAGER_ID, VENDORID } from '../utils/constant';
import { BILL_DATE_ERROR, BILL_DATE_RANGE_ERROR, CGST_ERROR, DEPARTMENT_ERROR, GST_FIELD_REQUIRED_ERROR, IGST_ERROR, ITEM_ERROR, MIN_QUANTITY_ERROR, MIN_RATE_ERROR, PENDING_DETAILS_MESSAGE, QUANTITY_ERROR, RATE_ERROR, SGST_ERROR, SUBTOTAL_ERROR, UPLOAD_DOCUMENT_ERROR, UPLOAD_MAX_FILE_ERROR, UPLOAD_MAX_SIZE_ERROR, UPLOAD_PDF_ERROR, UTGST_ERROR, VENDOR_ERROR, VALID_FORMAT_ERROR } from '../utils/helpers/globalErrorMessage';
import moment from 'moment';

const AddIndividuallBillValidation = () => {
  const [errors, setErrors] = useState({});

  const isValidFileType = (file) => {
    const allowedTypes = ["application/pdf"];
    return allowedTypes.includes(file.type);
  };

  const MAX_FILE_SIZE = 2 * 1024 * 1024;

  const isValidDateFormat = (dateStr) => {
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    return regex.test(dateStr);
  };

  const validateForm = (vendorId, billDate, roleId, departmentId, individualBillDocument, itemDescription, tax, itemDescriptionLineLevel, subTotal, subTotalLineLevel, lineLevelCheck, isVendorIdPresent) => {
    let errors = {};
    errors.itemDescription = []
    errors.itemDescriptionLineLevel = []
    let formIsValid = true;

    if (roleId === VENDORID) {
      if (!isVendorIdPresent) {
        formIsValid = false;
        errors.vendorId = PENDING_DETAILS_MESSAGE
      }
    }
    if (!vendorId) {
      formIsValid = false;
      errors.vendorId = VENDOR_ERROR
    }
    if (!billDate) {
      formIsValid = false;
      errors.billDate = BILL_DATE_ERROR;
    } else if (!isValidDateFormat(billDate)) {
      formIsValid = false;
      errors.billDate = VALID_FORMAT_ERROR;
    } else {
      const minAllowedDate = moment().subtract(1, 'months');
      const selectedDate = moment(billDate);

      if (selectedDate.isBefore(minAllowedDate, 'day')) {
        formIsValid = false;
        errors.billDate = BILL_DATE_RANGE_ERROR;
      }
    }

    if (!lineLevelCheck) {
      itemDescription.forEach((item, index) => {
        const lineItemErrors = {};

        if (!item.itemId) {
          formIsValid = false;
          lineItemErrors.itemId = ITEM_ERROR;
        }
        if (!item.rate) {
          formIsValid = false;
          lineItemErrors.rate = RATE_ERROR;
        }
        if (item.rate && item.rate == 0) {
          formIsValid = false;
          lineItemErrors.rate = MIN_RATE_ERROR;
        }
        if (!item.quantity) {
          formIsValid = false;
          lineItemErrors.quantity = QUANTITY_ERROR;
        }
        if (item.quantity && item.quantity == 0) {
          formIsValid = false;
          lineItemErrors.quantity = MIN_QUANTITY_ERROR;
        }
        if (Object.keys(lineItemErrors).length > 0) {
          errors.itemDescription[index] = lineItemErrors;
        }
        return lineItemErrors;
      });

      if (errors.itemDescription.length === 0) {
        delete errors.itemDescription;
      }
    } else {
      itemDescriptionLineLevel.forEach((item, index) => {
        const lineItemErrors = {};

        if (!item.itemId) {
          formIsValid = false;
          lineItemErrors.itemId = ITEM_ERROR;
        }
        if (!item.rate) {
          formIsValid = false;
          lineItemErrors.rate = RATE_ERROR;
        }
        if (item.rate && item.rate == 0) {
          formIsValid = false;
          lineItemErrors.rate = MIN_RATE_ERROR;
        }
        if (!item.quantity) {
          formIsValid = false;
          lineItemErrors.quantity = QUANTITY_ERROR;
        }
        if (item.quantity && item.quantity == 0) {
          formIsValid = false;
          lineItemErrors.quantity = MIN_QUANTITY_ERROR;
        }
        const hasGST = item.cgst || item.sgst || item.utgst || item.igst;
        if (!hasGST) {
          formIsValid = false;
          lineItemErrors.cgst = CGST_ERROR;
          lineItemErrors.sgst = SGST_ERROR;
          lineItemErrors.utgst = UTGST_ERROR;
          lineItemErrors.igst = IGST_ERROR;
        }
        if (item.cgst && !item.sgst) {
          formIsValid = false;
          lineItemErrors.sgst = SGST_ERROR;
        }
        if (!item.cgst && item.sgst) {
          formIsValid = false;
          lineItemErrors.cgst = CGST_ERROR;
        }
        if (Object.keys(lineItemErrors).length > 0) {
          errors.itemDescriptionLineLevel[index] = lineItemErrors;
        }
        return lineItemErrors;
      });

      if (errors.itemDescriptionLineLevel.length === 0) {
        delete errors.itemDescriptionLineLevel;
      }
    }

    if (!lineLevelCheck) {
      if (subTotal === 0) {
        formIsValid = false;
        errors.subTotal = SUBTOTAL_ERROR;
      }
      if (!tax.cgst && !tax.sgst && !tax.utgst && !tax.igst) {
        formIsValid = false;
        errors.tax = GST_FIELD_REQUIRED_ERROR;
      }
      else if (tax.cgst && !tax.sgst) {
        formIsValid = false;
        errors.tax = SGST_ERROR;
      }
      else if (!tax.cgst && tax.sgst) {
        formIsValid = false;
        errors.tax = CGST_ERROR;
      }
    } else {
      if (subTotalLineLevel === 0) {
        formIsValid = false;
        errors.subTotalLineLevel = SUBTOTAL_ERROR;
      }
    }
 // if (vendorId && subsidiaryId === 1) {
    //   if (subTotalUSA === 0) {
    //     formIsValid = false;
    //     errors.subTotalUSA = "Subtotal cannot be zero !";
    //   }
    //   if (!salesTax) {
    //     formIsValid = false;
    //     errors.salesTax = "Tax is required !";
    //   }
    // }
    if (roleId === ADMIN_MANAGER_ID || roleId === ADMIN_EXECUTIVE_ID) {
      if (!departmentId) {
        formIsValid = false;
        errors.departmentId = DEPARTMENT_ERROR;
      }
    }

    if (!individualBillDocument || individualBillDocument.length === 0) {
      formIsValid = false;
      errors.files = UPLOAD_DOCUMENT_ERROR;
    }
    else if (individualBillDocument) {
      for (const file of individualBillDocument) {
        if (!isValidFileType(file)) {
          formIsValid = false;
          errors.files = UPLOAD_PDF_ERROR;
          break;
        }
        if (file.size > MAX_FILE_SIZE) {
          formIsValid = false;
          errors.files = UPLOAD_MAX_SIZE_ERROR;
          break;
        }
        if (individualBillDocument.length > 5) {
          formIsValid = false;
          errors.files = UPLOAD_MAX_FILE_ERROR;
          break;
        }
      }
    }

    setErrors(errors);
    return formIsValid;
  };

  return { errors, setErrors, validateForm };
};

export default AddIndividuallBillValidation;